/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DunningSelectionConfigurationDto,
  ErrorResponse,
  ForecastDto,
  ForecastFilterRequestDto,
} from '../models/index';
import {
    DunningSelectionConfigurationDtoFromJSON,
    DunningSelectionConfigurationDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ForecastDtoFromJSON,
    ForecastDtoToJSON,
    ForecastFilterRequestDtoFromJSON,
    ForecastFilterRequestDtoToJSON,
} from '../models/index';

export interface DownloadRequest {
    dunningSelectionConfigurationDto: DunningSelectionConfigurationDto;
}

export interface DownloadFilteredForecastRequest {
    forecastFilterRequestDto?: ForecastFilterRequestDto;
}

export interface GetFilteredForecastRequest {
    forecastFilterRequestDto?: ForecastFilterRequestDto;
}

export interface GetForecastByConfigurationDtoRequest {
    dunningSelectionConfigurationDto: DunningSelectionConfigurationDto;
}

/**
 * 
 */
export class ForecastApi extends runtime.BaseAPI {

    /**
     * Download a CSV file with information about the fulfillment forecast. CSV file columns: `contractId`, `rulesetName`, `actions`, `openAmount`.  **Deprecated**: use `POST /forecast/filter/download` instead, which applies the same filters as the results table. This endpoint will be removed. 
     * Download CSV file
     */
    async downloadRaw(requestParameters: DownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.dunningSelectionConfigurationDto === null || requestParameters.dunningSelectionConfigurationDto === undefined) {
            throw new runtime.RequiredError('dunningSelectionConfigurationDto','Required parameter requestParameters.dunningSelectionConfigurationDto was null or undefined when calling download.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/forecast/download`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DunningSelectionConfigurationDtoToJSON(requestParameters.dunningSelectionConfigurationDto),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download a CSV file with information about the fulfillment forecast. CSV file columns: `contractId`, `rulesetName`, `actions`, `openAmount`.  **Deprecated**: use `POST /forecast/filter/download` instead, which applies the same filters as the results table. This endpoint will be removed. 
     * Download CSV file
     */
    async download(requestParameters: DownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download a CSV file with information about the fulfillment forecast for the selected forecast day, restricted to the given filters. The export contains all matching records, not only the records visible on the current table page. CSV file columns: `contractId`, `rulesetName`, `actions`, `openAmount`. 
     * Download filtered CSV file
     */
    async downloadFilteredForecastRaw(requestParameters: DownloadFilteredForecastRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/forecast/filter/download`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForecastFilterRequestDtoToJSON(requestParameters.forecastFilterRequestDto),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download a CSV file with information about the fulfillment forecast for the selected forecast day, restricted to the given filters. The export contains all matching records, not only the records visible on the current table page. CSV file columns: `contractId`, `rulesetName`, `actions`, `openAmount`. 
     * Download filtered CSV file
     */
    async downloadFilteredForecast(requestParameters: DownloadFilteredForecastRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadFilteredForecastRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a summary of the execution forecast for the selected forecast day, restricted to the given filters.  Filters are combined with `AND`; omitting a filter (or sending an empty list) means `All`. The dunning selection configuration is read from the backend configuration. 
     * Get filtered Forecast
     */
    async getFilteredForecastRaw(requestParameters: GetFilteredForecastRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ForecastDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/forecast/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForecastFilterRequestDtoToJSON(requestParameters.forecastFilterRequestDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ForecastDtoFromJSON(jsonValue));
    }

    /**
     * Get a summary of the execution forecast for the selected forecast day, restricted to the given filters.  Filters are combined with `AND`; omitting a filter (or sending an empty list) means `All`. The dunning selection configuration is read from the backend configuration. 
     * Get filtered Forecast
     */
    async getFilteredForecast(requestParameters: GetFilteredForecastRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ForecastDto> {
        const response = await this.getFilteredForecastRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a summary of the execution forecast.  **Deprecated**: use `POST /forecast/filter` instead, which supports filtering and resolves the dunning selection configuration on the backend. This endpoint will be removed. 
     * Get Forecast
     */
    async getForecastByConfigurationDtoRaw(requestParameters: GetForecastByConfigurationDtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ForecastDto>> {
        if (requestParameters.dunningSelectionConfigurationDto === null || requestParameters.dunningSelectionConfigurationDto === undefined) {
            throw new runtime.RequiredError('dunningSelectionConfigurationDto','Required parameter requestParameters.dunningSelectionConfigurationDto was null or undefined when calling getForecastByConfigurationDto.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/forecast`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DunningSelectionConfigurationDtoToJSON(requestParameters.dunningSelectionConfigurationDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ForecastDtoFromJSON(jsonValue));
    }

    /**
     * Get a summary of the execution forecast.  **Deprecated**: use `POST /forecast/filter` instead, which supports filtering and resolves the dunning selection configuration on the backend. This endpoint will be removed. 
     * Get Forecast
     */
    async getForecastByConfigurationDto(requestParameters: GetForecastByConfigurationDtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ForecastDto> {
        const response = await this.getForecastByConfigurationDtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
